import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

/* LAYOUTS */
import AuthLayout from "../themes/layouts/AuthLayout"
import MainLayout from "../themes/layouts/MainLayout"
import EmbedLayout from "../themes/layouts/EmbedLayout"
import EnrolmentLayout from "../themes/layouts/EnrolmentLayout"
import ErrorLayout from "../themes/layouts/ErrorLayout"

/* AUTH MODULES */
import LoginRoutes from "../modules/auth/routes"

/* FRONTEND MODULES */
import FE_EnrolmentRoutes from "../modules/frontend/routes-enrolment"
import FE_CourseRoutes from "../modules/frontend/routes-course"
import FE_URLShortener from "../modules/frontend/routes-url-shortener"
import FE_EmbedRoutes from "../modules/frontend/routes-embed"
import FE_DrivingTestRoutes from "../modules/frontend/routes-drivingtest"
import FE_KlarnaRouters from "../modules/frontend/routes-klarna"

/* APP MODULES */
import DashboardRoutes from "../modules/dashboard/routes"
import SettingRoutes from "../modules/settings/routes"
import UserRoutes from "../modules/users/routes"
import RoleRoutes from "../modules/roles/routes"
//import PermissionRoutes from "../modules/permissions/routes";
import OrganisationRoutes from "../modules/organisations/routes"
import CourseTemplatesRoutes from "../modules/coursetemplates/routes"
import LogRoutes from "../modules/logs/routes"
import QueueRoutes from "../modules/queues/routes"
import ClassRoutes from "../modules/classes/routes"
import CourseTypeGroupRoutes from "../modules/coursetypegroups/routes"
import CourseTypeRoutes from "../modules/coursetypes/routes"
import CourseRoutes from "../modules/courses/routes"
import TaskRoutes from "../modules/tasks/routes"
import DeliveryTestRoutes from "../modules/drivingtests/routes"
import CalendarRoutes from "../modules/calendar/routes"
import DrivingTestRoutes from "../modules/drivingtests/routes"
import AddressRoutes from "../modules/addresses/routes"
import ClassroomRoutes from "../modules/classrooms/routes"
import EnrolmentRoutes from "../modules/enrolments/routes"
import ParticipantRoutes from "../modules/participants/routes"
import AttendeeRoutes from "../modules/attendees/routes"
import ErrorRoutes from "../modules/errors/routes"
import ModuleTemplateRoutes from "../modules/moduletemplates/routes"
import CertificateRoutes from "../modules/certificates/routes"
import CustomerGroupRoutes from "../modules/customergroups/routes"
import CheckinRoutes from "../modules/checkin/routes"
import NotificationTemplateRoutes from "../modules/notificationtemplates/routes"
import StudentGroupRoutes from "../modules/studentgroups/routes"
import EducationProgramRoutes from "../modules/educationprograms/routes"
import ReportRoutes from "../modules/reports/routes"
import PassportRoutes from "../modules/passports/routes"
import DataRoutes from "../modules/data/routes"
import NotificationRoutes from "../modules/notifications/routes"
import ChangeLogRoutes from "../modules/changelog/routes"
import TestRoutes from "../modules/test/routes"
import EquipmentRoutes from "../modules/equipments/routes"
import EquipmentCategoryRoutes from "../modules/equipmentcategories/routes"
import EquipmentTypeRoutes from "../modules/equipmenttypes/routes"
import EquipmentManufacturerRoutes from "../modules/equipmentmanufacturers/routes"
import EquipmentModelRoutes from "../modules/equipmentmodels/routes"
import ChecklistRoutes from "../modules/checklist/routes"

const routes = [
  {
    path: "/auth/:locale",
    component: AuthLayout,
    children: [...LoginRoutes]
  },
  {
    path: "/f/:locale/enrolment",
    component: EnrolmentLayout,
    children: [...FE_EnrolmentRoutes]
  },
  {
    path: "/f/:locale/course",
    component: EnrolmentLayout,
    children: [...FE_CourseRoutes]
  },
  {
    path: "/f/:locale/drivingtest",
    component: EnrolmentLayout,
    children: [...FE_DrivingTestRoutes]
  },
  {
    path: "/f",
    component: EnrolmentLayout,
    children: [...FE_URLShortener]
  },
  {
    path: "/embed/:locale",
    component: EmbedLayout,
    children: [...FE_EmbedRoutes]
  },
  {
    path: "/f/:locale/klarna",
    component: EnrolmentLayout,
    children: [...FE_KlarnaRouters]
  },
  {
    path: "/error",
    component: ErrorLayout,
    children: [...ErrorRoutes]
  },
  {
    path: "/app",
    component: MainLayout,
    children: [
      ...DashboardRoutes,
      ...UserRoutes,
      ...RoleRoutes,
      //...PermissionRoutes,
      ...OrganisationRoutes,
      ...SettingRoutes,
      ...CourseTemplatesRoutes,
      ...LogRoutes,
      ...QueueRoutes,
      ...ClassRoutes,
      ...CourseTypeGroupRoutes,
      ...CourseTypeRoutes,
      ...CourseRoutes,
      ...TaskRoutes,
      ...DeliveryTestRoutes,
      ...CalendarRoutes,
      ...DrivingTestRoutes,
      ...AddressRoutes,
      ...ClassroomRoutes,
      ...EnrolmentRoutes,
      ...ParticipantRoutes,
      ...AttendeeRoutes,
      ...ModuleTemplateRoutes,
      ...CertificateRoutes,
      ...CustomerGroupRoutes,
      ...CheckinRoutes,
      ...NotificationTemplateRoutes,
      ...StudentGroupRoutes,
      ...EducationProgramRoutes,
      ...ReportRoutes,
      ...PassportRoutes,
      ...DataRoutes,
      ...NotificationRoutes,
      ...ChangeLogRoutes,
      ...TestRoutes,
      ...EquipmentRoutes,
      ...EquipmentCategoryRoutes,
      ...EquipmentTypeRoutes,
      ...EquipmentManufacturerRoutes,
      ...EquipmentModelRoutes,
      ...ChecklistRoutes,
    ]
  }
]

const router = new VueRouter({
  routes,
  mode: "history",
  base: process.env.BASE_URL
})

export default router
